import { render, staticRenderFns } from "./medicion-severidad-grafica.vue?vue&type=template&id=630e7c66&scoped=true&"
import script from "./medicion-severidad-grafica.vue?vue&type=script&lang=js&"
export * from "./medicion-severidad-grafica.vue?vue&type=script&lang=js&"
import style0 from "./medicion-severidad-grafica.vue?vue&type=style&index=0&id=630e7c66&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "630e7c66",
  null
  
)

export default component.exports